import { render, staticRenderFns } from "./FatherAndDaughter.vue?vue&type=template&id=5a8fad25&scoped=true&lang=pug&"
import script from "./FatherAndDaughter.vue?vue&type=script&lang=js&"
export * from "./FatherAndDaughter.vue?vue&type=script&lang=js&"
import style0 from "./FatherAndDaughter.vue?vue&type=style&index=0&id=5a8fad25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8fad25",
  null
  
)

export default component.exports